/**
 *
 */
// eslint-disable-next-line no-shadow
enum PLACEMENT {
  TOP = 'top',
  LEFT = 'left',
  BOTTOM = 'bottom',
  RIGHT = 'right',
}

export default PLACEMENT;
